<template>
  <quill-editor v-model="part.content"
                ref="editor"
                :options="quillOptions"
                v-if="state === 'editor'">
  </quill-editor>

  <div v-html="part.content" v-else></div>
</template>

<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'
export default {
  props: ['part', 'state'],
  components: {
    quillEditor,
  },
  mounted() {
    if (this.part.justCreated) {
      this.editor.focus();
      delete this.part.justCreated;
    }
  },
  data() {
    return {
      quillOptions: {
        modules: {
          toolbar:
          [
            ['bold', 'italic', 'strike', 'underline'],
            [{ 'indent': '-1'}, { 'indent': '+1' }],
            [{ 'list': 'ordered'}, { 'list': 'bullet' }]
          ]
        },
        formats: ['table', 'indent', 'list', 'bold', 'italic', 'underline', 'strike'],
        theme: 'bubble'
      }
    }
  },
  computed: {
    editor() {
      return this.$refs.editor.quill
    },
  }
}
</script>



// WEBPACK FOOTER //
// table.vue?532b83c2